import { Command } from "commander";
import { browser } from "./commands/browser/index.js";
import { init } from "./commands/init.js";
import { list } from "./commands/list.js";
import { handleError } from "./utils/handle-error.js";

const VERSION = process.env.VERSION ?? "0.0.1";

process.on("SIGINT", () => process.exit(0));
process.on("SIGTERM", () => process.exit(0));

// HACK: when stdout is piped into a process that closes early (e.g.
// `react-stack browser snapshot example.com | head`), Node throws an
// uncaught EPIPE on the next write. Exit cleanly instead of dumping a
// stack trace.
process.stdout.on("error", (error: NodeJS.ErrnoException) => {
  if (error.code === "EPIPE") process.exit(0);
});

const program = new Command()
  .name("react-stack")
  .description("Make your agent better at React. Installs React Stack skills into coding agents.")
  .version(VERSION, "-v, --version", "display the version number");

program.addCommand(init, { isDefault: true });
program.addCommand(list);
program.addCommand(browser);

program.parseAsync().catch((error: unknown) => {
  handleError(error);
});
